import React from 'react';
import { cn } from '@/lib/utils';
import { PartnrMark } from '@/components/partnr/kit/PartnrMark';

interface InlineAIButtonProps {
  onClick: (e: React.MouseEvent) => void;
  isActive?: boolean;
  className?: string;
}

export function InlineAIButton({ onClick, isActive = false, className }: InlineAIButtonProps) {
  return (
    <button
      onClick={(e) => {
        e.stopPropagation();
        onClick(e);
      }}
      onMouseDown={(e) => e.stopPropagation()}
      onPointerDown={(e) => e.stopPropagation()}
      className={cn(
        "absolute bottom-3 right-3 w-8 h-8 rounded-lg flex items-center justify-center transition-all duration-200 z-10",
        isActive
          ? "bg-partnr text-partnr-foreground shadow-lg"
          : "bg-muted/80 hover:bg-partnr/20 text-muted-foreground hover:text-partnr backdrop-blur-sm",
        className
      )}
      title="Ask Partnr"
    >
      <PartnrMark size={16} />
    </button>
  );
}
